/** A value to write, the way the backend takes it: option ids, text or an ISO date. */
export type SaveMetapropertyValue = {
	id: string;
	value: { optionIds: string[] } | { text: string } | { date: string };
};

/**
 * JSON body of the save request, or undefined when there is nothing to send, so the request keeps
 * having no body and no `Content-Type` as before.
 */
export function buildSaveBody({
	name,
	metapropertyValues,
}: {
	name?: string;
	metapropertyValues?: SaveMetapropertyValue[];
}): string | undefined {
	const hasValues = Boolean(metapropertyValues?.length);

	if (!name && !hasValues) {
		return undefined;
	}

	return JSON.stringify({
		...(name && { assetName: name }),
		...(hasValues && { metapropertyValues }),
	});
}
